<div class="main">
  <div class="dashboard-header">
    <img [src]="getImageUrl()" alt="Logo" id="logo" style="width: 150px;margin:6px;">
  </div>
  <div class="navbar" style="justify-content: space-between;">
    <div class="nav-item" style="font-size: 13px;">
      <a (click)="customer()"> Customer Profile </a>
      <!-- <div  class="dropdown">
                <a > Customer Profile</a>
            </div> -->
    </div>
    <div class="user-info" style="margin-right: 11px;">
      <!-- <span>Welcome : User</span><i class="fas fa-user" (click)="openprofilePopup();"></i> -->
      <div class="nav-item" style="font-size: 15px;">
        <span style="color: black;">Welcome : {{userName ? userName : 'User'}}</span><a><i class="fas fa-user"></i></a>
        <div class="dropdown">
          <a style="white-space: nowrap;" (click)="openAddForm(addChangePasswordModal);this.showConfirmPassword = false;
            this.showNewPassword = false;
          "> Change Password</a>
          <a (click)="openAddForm(openLogOutModel)"> Logout</a>
        </div>
      </div>
    </div>
  </div>

    <!-- subscription-popup.component.html -->
<ng-template #addSubscriptiondModal let-modal>
  <div class="popup-overlay">
    <div class="popup-container">
      <div class="popup-header">
        <h3>Create New Subscription</h3>
        <button class="close-btn" (click)="closePopup()">×</button>
      </div>

      <div class="popup-body">
        <div class="form-row">

          <div class="form-group">
            <label>Customer MSISDN</label>
            <input type="text" [(ngModel)]="phoneNumber" readonly class="readonly-input"  />
          </div>

          <div class="form-group">
            <label>Select Currency <span class="req">*</span></label>
            <select [(ngModel)]="selectedCurrency" #cur="ngModel" required>
              <option value="" disabled>Select Currency</option>
              <option value="ZWG">ZWG</option>
              <option value="USD">USD</option>
            </select>
            <div class="err" *ngIf="cur.touched && cur.invalid">This field is required</div>
          </div>

        </div>

        <div class="form-row">

          <div class="form-group">
            <label>Select Plan <span class="req">*</span></label>
            <select [(ngModel)]="selectedPlan" #plan="ngModel" required>
              <option value="" disabled>Select Plan</option>
              <option value="Daily">Daily</option>
              <option value="Weekly">Weekly</option>
              <option value="Monthly">Monthly</option>
            </select>
            <div class="err" *ngIf="plan.touched && plan.invalid">This field is required</div>
          </div>

          <div class="form-group">
            <label>Channel</label>
            <input type="text" value="CCI" readonly class="readonly-input" />
          </div>

        </div>
      </div>

      <div class="popup-footer">
       <button class="btn btn-primary"
        [disabled]="cur.invalid || plan.invalid"
        (click)="nextStep()">
         Next: Select Ringtone
        </button>

        <button class="btn btn-cancel" (click)="closePopup()">Cancel</button>
      </div>
    </div>
  </div>
</ng-template>


  
  <ng-container>
    <span style="position: relative; bottom: -7em; left: 1em; font-size: 12px;">
      <i class="fas fa-home"></i> / Customer Profile / View
    </span>
    <div class="container-fluid">
      <div class="row">
      <div [ngClass]="(errorMessage && !noActiveSubscription) ? 'no-active-container' : 'customer-tool-container'">
        <div class="customer-card">

          <div class="customer-card-header text-center">
            <h5>Customer Care Tool</h5>
          </div>

          <div class="customer-card-body">
            <div class="button-wrapper">
              <button class="bulk-upload-btnbtn get-details-btn" (click)="goToBulkUpload('SUB')">
                <i class="fa fa-upload"></i>
                Bulk Upload Subscriptions
              </button>
            </div>
             <div class="button-wrapper">
              <button class="bulk-upload-btnbtn get-details-btn" (click)="goToBulkUpload('UNSUB')">
                <i class="fa fa-upload"></i>
                Bulk Upload UnSubscriptions
              </button>
            </div>
            <div class="or-divider">
              <span>OR</span>
            </div>

            <div class="phone-section">
              <label for="phone-number" class="customer-label">Enter Number</label>

              <input
                type="text"
                id="phone-number"
                [readOnly]="noActiveSubscription"
                class="customer-input phone-bordered"
                placeholder="263xxxxxxxx"
                [(ngModel)]="phoneNumber"
                name="phoneNumber"
                required
                (keypress)="allowOnlyNumbers($event)"
                maxlength="13"
              />
            </div>

            <form (submit)="getDetails()">

              <div *ngIf="errorMessage" class="no-subscription-box">

                <div class="icon-text" *ngIf="noActiveSubscription">
                  <div class="info-icon-circle">
                    <span class="info-symbol">i</span>
                  </div>

                  <div class="text-content">
                    <p class="no-subscription-title">No Active Subscription Found</p>
                    <p class="no-subscription-text">
                      This number ({{ phoneNumber || '263xxxxxxxx' }}) doesn’t have any active subscription.
                      Would you like to create a new subscription?
                    </p>
                  </div>
                </div>

                <div *ngIf="!noActiveSubscription" class="text-danger">
                  {{ errorMessage }}
                </div>

              </div>
              
              
              <div *ngIf="!noActiveSubscription" class="button-wrapper">
                <button type="submit" class="btn get-details-btn">Get Details</button>
              </div>

              <div *ngIf="errorMessage && noActiveSubscription" class="button-group">
                <button type="button" class="btn search-another-btn" (click)="search_another()">Search Another Number</button>
                <button type="button" class="btn create-subscription-btn" (click)="openAddForm(addSubscriptiondModal)">
                  + Create New Subscription
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
        <!-- Right Panel -->
        <div class="col-md-8" *ngIf="showDetails"
          style="border: 1px solid #ccc; padding-left: 15px; padding-top: 15px; margin-left: 30px; width: 72%; padding-right: 15px;">
          <div class="card mb-2" style="min-height: 40px;">
            <div class="card-body mt-2">
              <a style="padding-left: 13px; cursor: pointer;" (click)="showSubscriptions()">Active Subscription
                Details</a>
              <div class="button-group" style="float: right; margin-bottom: 8px; margin-top: 0px;">
                <button
                  style="background-color: green; color: white; border: none; padding: 5px 10px; margin-right: 5px; border-radius: 5px; cursor: pointer;"
                  (click)="setRingtone()">
                  Set Ringtone
                </button>
              </div>
            </div>
          </div>

          <div class="card mt-2 mb-2" *ngIf="showSubscription" style="border: 1px solid #ccc; padding: 15px;">
            <h5 class="mb-3"> Active Subscription Details</h5>
            <div class="row mb-3">
              <div class="col-md-9">
                <label for="rowsPerPage" class="form-label me-2">Rows per page:</label>

                <select id="rowsPerPage" class="form-select d-inline-block w-auto" [(ngModel)]="rowsPerPage2"
                  (change)="updatePaginationuser()">
                  <option *ngFor="let size of pageSizes" [value]="size">
                    {{ size }}
                  </option>
                </select>
              </div>
              <div class="col-md-3 text-end">
                <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchQuery"
                  (ngModelChange)="filteruser()" />
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr style="text-align: center;">
                    <th></th>
                    <th (click)="sortuser('subsStatus')">Status <span *ngIf="sortColumnuser === 'subsStatus'">{{
                        sortDirectionuser === 'asc' ? '↑' : '↓' }}</span></th>
                    <th (click)="sortuser('subscriptionDate')">Subscription Date <span
                        *ngIf="sortColumnuser === 'subscriptionDate'">{{ sortDirectionuser === 'asc' ? '↑' : '↓'
                        }}</span></th>
                    <th (click)="sortuser('channel')">Channel <span *ngIf="sortColumnuser === 'channel'">{{
                        sortDirectionuser === 'asc' ? '↑' : '↓'
                        }}</span></th>
                    <th (click)="sortuser('currency')">Currency <span *ngIf="sortColumnuser === 'currency'">{{
                        sortDirectionuser === 'asc' ? '↑' : '↓'
                        }}</span></th>
                    <th (click)="sortuser('phone')">Customer MSISDN <span *ngIf="sortColumnuser === 'phone'">{{
                        sortDirectionuser === 'asc' ? '↑' : '↓' }}</span></th>
                    <th (click)="sortuser('toneCode')">Tone Code <span *ngIf="sortColumnuser === 'toneCode'">{{
                        sortDirectionuser === 'asc' ? '↑' : '↓' }}</span></th>
                    <th (click)="sortuser('toneName')">Tone Name <span *ngIf="sortColumnuser === 'toneName'">{{
                        sortDirectionuser === 'asc' ? '↑' : '↓' }}</span></th>
                    <th (click)="sortuser('renewalDate')">Renewal Date <span *ngIf="sortColumnuser === 'renewalDate'">{{
                        sortDirectionuser === 'asc' ? '↑' : '↓' }}</span></th>
                    <th (click)="sortuser('planName')">Plan <span *ngIf="sortColumnuser === 'planName'">{{
                        sortDirectionuser === 'asc' ? '↑' : '↓' }}</span></th>
                    <th>Options</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngIf="filtereduser.length === 0">
                    <td colspan="11" class="text-center text-danger">No matching records found</td>
                  </tr>
                  <tr *ngFor="let transaction of paginateduser; let i = index" style="text-align: center;">
                    <td>
                      <span class="status-dot"
                        [ngClass]="{'green': transaction.subsStatus === 'Active', 'red': transaction.subsStatus === 'Renewal System Error','orange':transaction.subsStatus === 'Low Balance', 'yellow':transaction.subsStatus === 'Submitted' }">
                      </span>
                    </td>
                    <td>
                      {{ transaction.subsStatus || 'N/A' }}
                    </td>


                    <td>{{ transaction.subscriptionDate ? (transaction.subscriptionDate | date: 'dd-MM-yyyy, hh:mm a') :
                      'N/A'}}</td>
                    <td>
                      {{ transaction.channel || 'N/A' }}
                    </td>
                    <td>
                      {{ transaction.currency || 'N/A' }}
                    </td>
                    <td>{{ transaction.phone || 'N/A' }}</td>
                    <td>{{ transaction.toneCode || 'N/A' }}</td>
                    <td>{{ transaction.toneName || 'N/A' }}</td>
                    <td>{{ transaction.renewalDate ? (transaction.renewalDate | date: 'dd-MM-yyyy, hh:mm a') : 'N/A' }}
                    </td>
                    <td>{{ transaction.planName || 'N/A' }}</td>
                    <td><button class="btn btn-danger" style="cursor:pointer"
                        (click)="openDeativateRington(deativateRingtoneModal, transaction.userId,transaction.toneCode )">Deactivate
                        Ringtone</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- <nav *ngIf="filtereduser.length > rowsPerPage2" style="margin-top: 10px;">
              <div class="d-flex justify-content-between align-items-center w-100">
                <span>
                  Showing {{ getStartIndex() }} to {{ getEndIndex() }} of {{ filtereduser.length }} entries
                </span>

                <div>
                  <button class="btn btn-secondary me-2" [disabled]="currentPage2 === 1 || filtereduser.length === 0"
                    (click)="changePage2(currentPage2 - 1)">
                    Previous
                  </button>
                  <ng-container *ngFor="let page of getPagesuser()">
                    <button *ngIf="!isValidPage(page)" class="btn1 btn-secondary me-2" disabled>
                      {{ page }}
                    </button>
                    <button *ngIf="isValidPage(page)" class="btn1 btn-secondary me-2"
                      [class.active]="page === currentPage2" (click)="changePage2(page)">
                      {{ page }}
                    </button>
                  </ng-container>
                  <button class="btn btn-secondary"
                    [disabled]="currentPage2 === totalPages2 || filtereduser.length === 0"
                    (click)="changePage2(currentPage2 + 1)">
                    Next
                  </button>
                </div>
              </div>
            </nav> -->
            <nav *ngIf="filtereduser.length > rowsPerPage2" style="margin-top: 10px;">
              <div class="pagination-controls">
                <!-- Pagination Info -->
                <span>
                  Showing {{ getStartIndex() }} to {{ getEndIndex() }} of {{ filtereduser.length }} entries
                </span>

                <!-- Pagination Buttons -->
                <div>
                  <button class="btn btn-secondary me-2 pre-class"
                    [disabled]="currentPage2 === 1 || filtereduser.length === 0"
                    (click)="changePage2(currentPage2 - 1)">
                    Previous
                  </button>

                  <ng-container *ngFor="let page of getPagesuser()">
                    <button [disabled]="currentPage2 === page" [ngStyle]="{
                      'background': !isValidPage(page)  ? 'none' : '',
                      'pointer-events':!isValidPage(page)  ? 'none' : '',
                      'padding':!isValidPage(page)  ? '0' : ''
                    }" [ngClass]="(currentPage2 === page) ? 'led':''" class="btn btn-secondary me-2"
                      [class.active]="page === currentPage2" (click)="changePage2(page)">
                      {{ page }}
                    </button>
                  </ng-container>

                  <button class="btn btn-secondary pre-class"
                    [disabled]="currentPage2 === totalPages2 || filtereduser.length === 0"
                    (click)="changePage(currentPage2 + 1)">
                    Next
                  </button>
                </div>
              </div>
            </nav>

          </div>

          <div class="card mb-2" style="min-height: 40px;">
            <div class="card-body  mt-2" style="cursor: pointer;" (click)="showSMSLogs()">
              <a style="padding-left: 13px;">SMS History</a>
            </div>
          </div>
          <div class="card mt-2 mb-2" *ngIf="showsmsLogs" style="border: 1px solid #ccc; padding: 15px;">
            <h5 class="mb-3">SMS History</h5>
            <div class="row mb-3">
              <div class="col-md-9">
                <label for="rowsPerPage" class="form-label me-2">Rows per page:</label>
                <select id="rowsPerPage" class="form-select d-inline-block w-auto" [(ngModel)]="rowsPerPage1"
                  (change)="updatePaginationsms()">
                  <option *ngFor="let size of pageSizes" [value]="size">
                    {{ size }}
                  </option>
                </select>
              </div>
              <div class="col-md-3 text-end">
                <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchQuerysms"
                  (ngModelChange)="filtersms()" />
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr style="text-align: center;">
                    <th (click)="sortsms('date')">Date <span *ngIf="sortColumnsms === 'date'">{{ sortDirectionsms ===
                        'asc' ? '↑' : '↓' }}</span></th>
                    <th (click)="sortsms('message')">Message <span *ngIf="sortColumnsms === 'message'">{{
                        sortDirectionsms === 'asc' ? '↑' : '↓' }}</span></th>
                    <th (click)="sortsms('type')">Type <span *ngIf="sortColumnsms === 'type'">{{ sortDirectionsms ===
                        'asc' ? '↑' : '↓' }}</span></th>
                    <th (click)="sortsms('status')">Status <span *ngIf="sortColumnsms === 'status'">{{ sortDirectionsms
                        === 'asc' ? '↑' : '↓' }}</span></th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngIf="filteredsms.length === 0">
                    <td colspan="5" class="text-center text-danger">No matching records found</td>
                  </tr>
                  <tr *ngFor="let sms of paginatedsms; let i = index" style="text-align: center;">
                    <td>{{ sms.date ? (sms.date | date: 'dd-MM-yyyy, hh:mm a') : 'N/A' }}</td>
                    <td>{{ sms.message || 'N/A' }}</td>
                    <td>{{ sms.type || 'N/A'}}</td>
                    <td>{{ sms.status || 'N/A' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- <nav *ngIf="filteredsms.length > rowsPerPage1" style="margin-top: 10px;">
              <div class="d-flex justify-content-between align-items-center w-100">
                <span>
                  Showing {{ getStartIndexsms() }} to {{ getEndIndexsms() }} of {{ filteredsms.length }} entries
                </span>
                <div>
                  <button class="btn btn-secondary me-2" [disabled]="currentPage1 === 1 || filteredsms.length === 0"
                    (click)="changePage1(currentPage1 - 1)">
                    Previous
                  </button>
                  <ng-container *ngFor="let page of getPagessms()">
                    <button *ngIf="!isValidPage(page)" class="btn1 btn-secondary me-2" disabled>
                      {{ page }}
                    </button>
                    <button *ngIf="isValidPage(page)" class="btn1 btn-secondary me-2"
                      [class.active]="page === currentPage1" (click)="changePage1(page)">
                      {{ page }}
                    </button>
                  </ng-container>
                  <button class="btn btn-secondary"
                    [disabled]="currentPage1 === totalPages1 || filteredsms.length === 0"
                    (click)="changePage1(currentPage1 + 1)">
                    Next
                  </button>
                </div>
              </div>
            </nav> -->
            <nav *ngIf="filteredsms.length > rowsPerPage1" style="margin-top: 10px;">
              <div class="pagination-controls">
                <!-- Pagination Info -->
                <span>
                  Showing {{ getStartIndexsms() }} to {{ getEndIndexsms() }} of {{ filteredsms.length }} entries
                </span>

                <!-- Pagination Buttons -->
                <div>
                  <button class="btn btn-secondary me-2 pre-class"
                    [disabled]="currentPage1 === 1 || filteredsms.length === 0" (click)="changePage1(currentPage1 - 1)">
                    Previous
                  </button>

                  <ng-container *ngFor="let page of getPagessms()">
                    <button [disabled]="currentPage1 === page" [ngStyle]="{
                      'background': !isValidPage(page)  ? 'none' : '',
                      'pointer-events':!isValidPage(page)  ? 'none' : '',
                      'padding':!isValidPage(page)  ? '0' : ''
                    }" [ngClass]="(currentPage1 === page) ? 'led':''" class="btn btn-secondary me-2"
                      [class.active]="page === currentPage1" (click)="changePage1(page)">
                      {{ page }}
                    </button>
                  </ng-container>

                  <button class="btn btn-secondary pre-class"
                    [disabled]="currentPage1 === totalPages1 || filteredsms.length === 0"
                    (click)="changePage1(currentPage1 + 1)">
                    Next
                  </button>
                </div>
              </div>
            </nav>
          </div>
          <div class="card mb-2" style="min-height: 40px;">
            <div class="card-body  mt-2" style="cursor: pointer;" (click)="showTransactionLogs()">
              <a style="padding-left: 13px;">Transaction History</a>
            </div>
          </div>
          <div class="card mt-2 mb-2" *ngIf="showLogs" style="border: 1px solid #ccc; padding: 15px;">
            <h5 class="mb-3">Transaction History</h5>
            <div class="row mb-3">
              <div class="col-md-9">
                <label for="rowsPerPage" class="form-label me-2">Rows per page:</label>
                <select id="rowsPerPage" class="form-select d-inline-block w-auto" [(ngModel)]="rowsPerPage"
                  (change)="updatePagination()">
                  <option *ngFor="let size of pageSizes" [value]="size">
                    {{ size }}
                  </option>
                </select>
              </div>
              <div class="col-md-3 text-end">
                <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchQuerytrasaction"
                  (ngModelChange)="filterTransactions()" />
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr style="text-align: center;">
                    <th (click)="sortTable('toneCode')">Tone Code <span [class]="getSortIcon('toneCode')"></span></th>
                    <th (click)="sortTable('date')">Date <span [class]="getSortIcon('date')"></span></th>
                    <th (click)="sortTable('currency')">Currency <span [class]="getSortIcon('currency')"></span></th>
                    <th (click)="sortTable('plan')">Plan <span [class]="getSortIcon('plan')"></span></th>
                    <th (click)="sortTable('amount')">Amount <span [class]="getSortIcon('amount')"></span></th>
                    <th (click)="sortTable('type')">Type <span [class]="getSortIcon('type')"></span></th>
                    <th (click)="sortTable('mode')">Mode <span [class]="getSortIcon('mode')"></span></th>
                    <th (click)="sortTable('status')">Status <span [class]="getSortIcon('status')"></span></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="filteredTransactions.length === 0">
                    <td colspan="8" class="text-center text-danger">No matching records found</td>
                  </tr>
                  <tr *ngFor="let transaction of paginatedTransactions; let i = index" style="text-align: center;">
                    <td>{{ transaction.toneCode || 'N/A' }}</td>
                    <td>{{ transaction.date ? (transaction.date | date: 'dd-MM-yyyy, hh:mm a') : 'N/A' }}</td>
                    <td>{{ transaction.currency || 'N/A' }}</td>
                    <td>{{ transaction.plan || 'N/A' }}</td>
                    <td>{{ transaction.amount || 'N/A' }}</td>
                    <td>{{ transaction.type || 'N/A' }}</td>
                    <td>{{ transaction.mode || 'N/A' }}</td>
                    <td>{{ transaction.status || 'N/A' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- <nav *ngIf="filteredTransactions.length > rowsPerPage" style="margin-top: 10px;">
              <div class="d-flex justify-content-between align-items-center w-100">
                <span>
                  Showing {{ getStartIndextransaction() }} to {{ getEndIndextransaction() }} of {{
                  filteredTransactions.length }} entries
                </span>
                <div>
                  <button class="btn btn-secondary me-2"
                    [disabled]="currentPage === 1 || filteredTransactions.length === 0"
                    (click)="changePage(currentPage - 1)">
                    Previous
                  </button>
                  <ng-container *ngFor="let page of getPages()">
                    <button *ngIf="!isValidPage(page)" class="btn1 btn-secondary me-2" disabled>
                      {{ page }}
                    </button>
                    <button *ngIf="isValidPage(page)" class="btn1 btn-secondary me-2"
                      [class.active]="page === currentPage" (click)="changePage(page)">
                      {{ page }}
                    </button>
                  </ng-container>
                  <button class="btn btn-secondary"
                    [disabled]="currentPage === totalPages || filteredTransactions.length === 0"
                    (click)="changePage(currentPage + 1)">
                    Next
                  </button>
                </div>
              </div>

            </nav> -->
            <nav *ngIf="filteredTransactions.length > rowsPerPage" style="margin-top: 10px;">
              <div class="pagination-controls">
                <!-- Pagination Info -->
                <span>
                  Showing {{ getStartIndextransaction() }} to {{ getEndIndextransaction() }} of {{
                  filteredTransactions.length }} entries
                </span>

                <!-- Pagination Buttons -->
                <div>
                  <button class="btn btn-secondary me-2 pre-class"
                    [disabled]="currentPage === 1 || filteredTransactions.length === 0"
                    (click)="changePage(currentPage - 1)">
                    Previous
                  </button>

                  <ng-container *ngFor="let page of getPages()">
                    <button [disabled]="currentPage === page" [ngStyle]="{
                      'background': !isValidPage(page)  ? 'none' : '',
                      'pointer-events':!isValidPage(page)  ? 'none' : '',
                      'padding':!isValidPage(page)  ? '0' : ''
                    }" [ngClass]="(currentPage === page) ? 'led':''" class="btn btn-secondary me-2"
                      [class.active]="page === currentPage" (click)="changePage(page)">
                      {{ page }}
                    </button>
                  </ng-container>

                  <button class="btn btn-secondary pre-class"
                    [disabled]="currentPage === totalPages || filteredTransactions.length === 0"
                    (click)="changePage(currentPage + 1)">
                    Next
                  </button>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>

  </ng-container>

  <ng-template #addChangePasswordModal let-modal>
    <div class="modal-dialog">
      <div class="modal-content change-password-container">
        <div class="modal-header">
          <h5 class="modal-title">Change Password</h5>
          <button type="button" class="btn-close" (click)="onCancelchange()"></button>
        </div>
        <div class="modal-body" style="padding: 20px;margin-top: -20px;">
          <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
            <!-- Current Password -->
            <div class="form-group">
              <label for="oldPassword">Current Password <span class="text-danger">*</span></label>
              <div class="input-group">
                <input (keypress)="preventSpace($event)" maxlength="20" [type]="showOldPassword ? 'text' : 'password'"
                  id="oldPassword" autocomplete="new-password" class="form-control"
                  style="margin-top: -12px;margin-bottom: -5px;" formControlName="oldPassword"
                  placeholder="Enter Current Password" />
                <i class="fa" [ngClass]="showOldPassword ? 'fa-eye-slash' : 'fa-eye'"
                  (click)="togglePasswordVisibility('old')"
                  style="position: absolute; right: 10px; top: 45%; transform: translateY(-50%); cursor: pointer; z-index: 10;">
                </i>
              </div>
              <div *ngIf="oldPassword?.invalid && oldPassword?.touched" class="text-danger">
                <div *ngIf="oldPassword?.errors?.['required']">Current Password is required</div>
              </div>
            </div>

            <!-- New Password -->
            <div class="form-group">
              <label for="newPassword">New Password <span class="text-danger">*</span></label>
              <div class="input-group">
                <input style="margin-top: -12px;margin-bottom: -5px;" (keypress)="preventSpace($event)" maxlength="20"
                  [type]="showNewPassword ? 'text' : 'password'" autocomplete="new-password" id="newPassword"
                  class="form-control" formControlName="newPassword" placeholder="Enter New Password" />
                <i class="fa" [ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"
                  (click)="togglePasswordVisibility('new')"
                  style="position: absolute; right: 10px; top: 45%; transform: translateY(-50%); cursor: pointer; z-index: 10;">
                </i>
              </div>
              <div *ngIf="newPassword?.invalid && newPassword?.touched" class="text-danger">
                <div *ngIf="newPassword?.errors?.['required']">Password is required</div>
                <div *ngIf="newPassword?.errors?.['pattern']">Password must be at least 8 characters long, contain at
                  least one number, one uppercase letter, and one lowercase letter</div>
                <div *ngIf="newPassword?.errors?.['sameAsOldPassword']">New Password must be different from Current
                  Password</div>
              </div>
            </div>

            <!-- Confirm Password -->
            <div class="form-group" style="margin-bottom: 40px;">
              <label for="confirmPassword">Confirm Password<span style="color: red;margin-left: 5px;">*</span></label>
              <div class="input-group" style="position: relative;">
                <input style="margin-top: -12px;margin-bottom: -10px;" (keypress)="preventSpace($event)" maxlength="20"
                  autocomplete="new-password" [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword"
                  class="form-control" formControlName="confirmPassword" placeholder="Confirm New Password" />
                <i class="fa" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"
                  (click)="togglePasswordVisibility('confirm')"
                  style="position: absolute; right: 10px; top: 45%; transform: translateY(-50%); cursor: pointer; z-index: 10;">
                </i>
              </div>
              <div *ngIf="confirmPassword?.invalid && confirmPassword?.touched" class="text-danger">
                <div *ngIf="confirmPassword?.errors?.['required']">Confirm Password is required</div>
                <div *ngIf="confirmPassword?.errors?.['mustMatch']">Passwords do not match</div>
              </div>
            </div>

            <!-- <div *ngIf="passwordErrorMessage" class="text-danger">
              {{ passwordErrorMessage }}
            </div>
            <div *ngIf="successMessage" class="success-message">
              {{ successMessage }}
            </div> -->
            <div class="modal-footer" style="margin-top: 20px;padding: 0 !important;">
              <button type="button" class="btn custom-btn-change-password" style="margin-right:10px"
                (click)="onSubmit()">
                Change Password
              </button>
              <button type="button" class="btn btn-secondary custom-btn-cancel" (click)="modal.dismiss('Cancel click')">
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

  </ng-template>

  <ng-template #deativateRingtoneModal let-modal>
    <div class="modal-dialog">
      <div class="modal-content change-password-container">
        <div class="modal-header">
          <h5 class="modal-title">Deactivate Ringtone</h5>
          <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body" style="padding: 20px;">
          <form>
            <div class="confirmation-message">
              <p>Are you sure you want to deactivate your ringtone?</p>
              <div class="button-group" style="margin-top: 20px;">
                <button type="button" class="btn custom-btn-change-password poupo"
                  style="margin-right:10px; cursor: pointer;"
                  (click)="DeactivateAccount(selectedUserId, rbtIsrc)">Deactivate</button>
                <button type="button" class="btn btn-secondary custom-btn-cancel" style=" cursor: pointer"
                  (click)="modal.dismiss('Cancel click')">Cancel</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div id="deativateToast" class="toast">
        <i class="fa fa-check" style=" margin-right: 5px;"></i>
        <p style="display: inline;">Ringtone Deactivate Successfully</p>
      </div>
    </div>
  </ng-template>
  <ng-template #blockModal let-modal>
    <div class="modal-dialog">
      <div class="modal-content change-password-container">
        <div class="modal-header">
          <h5 class="modal-title">Block Caller Msisidn</h5>
          <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body" style="padding: 20px;">
          <form>
            <div class="form-group">
              <label for="currentPassword">Customer Msisidn</label>
              <input type="password" id="currentPassword" class="form-control" placeholder="Enter Current Password"
                required>
            </div>
            <div class="form-group">
              <label for="newPassword">Choose Type</label>
              <input type="password" id="newPassword" class="form-control" placeholder="Enter New Password" required>
            </div>
            <div class="form-group">
              <label for="confirmPassword">Caller Msisidn</label>
              <input type="password" id="confirmPassword" class="form-control" placeholder="Confirm New Password"
                required>
            </div>
            <div class="button-group" style="margin-top: 20px;">
              <button type="button" class="btn btn-primary"
                style="margin-right: 10px;background-color:white; color:black; font-weight: 400; font-size: 14px; border: 1px solid gray;">
                Block</button>
              <button type="button" class="btn btn-secondary"
                style="color: #fff;background-color: #c9302c;border-color: #ac2925;font-size: 14px;"
                (click)="modal.dismiss('Cancel click')">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #openLogOutModel let-modal>
    <div class="modal-dialog">
      <div class="modal-content change-password-container">
        <div class="modal-header">
          <h5 class="modal-title">Confirm {{statusChangeText}}</h5>
          <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body" style="padding: 20px;height: 15vh;width:100vw; word-break:break-all;">
          <p style="margin-top: 15px; margin-left:5px">Are you sure you want to logout ?</p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-success custom-btn-logout" (click)="logout()">
            Logout
          </button>
          <button class="btn btn-secondary custom-btn-cancel" (click)="modal.dismiss('Cross click')">Cancel
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <p style="color: white">Please Wait. </p>
</ngx-spinner>